import React, { useEffect } from "react";

import { FaArrowRight, FaRegClock } from "react-icons/fa6";
import { Link } from "react-router-dom";

const NeuromotorRehabilitation = () => {
    return (
        <div className="container mx-auto flex flex-col justify-between px-4 lg:px-6 mb-60 z-30">
            <div className="flex flex-col my-12">
                <h1 className="w-full mx-auto text-left text-blue-primary font-normal text-3xl lg:text-4xl mt-6 mb-8 lg:mx-0">
                    <span className="font-bold">CENTRO DI RIABILITAZIONE NEUROMOTORIA</span> E DI FISIOTERAPIA
                </h1>

                <p className="text-blue-text text-lg lg:text-2xl font-bold">
                    FORM SEGNALAZIONI ODV
                </p>
                <p className="text-lg">
                    Il contenuto è protetto da password. Per visualizzarlo inserisci di seguito la password:
                </p>

                <div className="my-3 flex">
                    <input className="text-2xl border-[1.5px] border-blue-primary h-[3.2rem] pl-2 text-blue-text focus:border-none focus:outline-blue-primary focus:outline-2"/>
                    <button className="h-[3.2rem] w-[6rem] flex justify-center items-center bg-blue-primary text-white font-bold">INVIA</button>
                </div>

            </div>
        </div>
    )
}

export default NeuromotorRehabilitation;